





























































































































































































































































import { Account, Building, Company, CvValue, Permission, Provider } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import AccountMetadataForm from '@/components/AccountMetadataForm.vue'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { AccountUtils } from '@/utils/account-utils'
import {
  CV_VALUE_COUNTRY,
  CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT,
  ACCOUNT_PROFILE_USER,
  ACCOUNT_PROFILE_ADMIN
} from '@/utils/constants'
import store from '@/store'

@Component({
  components: { AccountMetadataForm }
})
export default class UpsertAccountModal extends Vue {
  @Prop({ required: false }) account: Account

  private countries: CvValue[] = []
  private businessUnits: CvValue[] = []
  private companies: Company[] = []
  private buildings: Building[] = []
  private providers: Provider[] = []
  private profiles: string[] = []
  private ACCOUNT_PROFILE_ADMIN = ACCOUNT_PROFILE_ADMIN
  private metaValid = true

  @Watch('account', { deep: true })
  onAccountChanged() {
    this.updateAccount()
  }

  private accountSave: Account = {
    accountId: '',
    firstName: '',
    lastName: '',
    active: true,
    country: undefined,
    businessUnit: undefined,
    responsibleCompany: undefined,
    profile: ACCOUNT_PROFILE_USER,
    companyId: undefined,
    buildingId: undefined,
    providerId: undefined,
    editorialStatus: undefined,
    meta: {},
    createdOn: '',
    updatedOn: ''
  }

  get newAccount() {
    return this.account == null || !this.account.accountId
  }

  get countriesSelect() {
    return this.countries
  }

  get businessUnitsSelect() {
    return this.businessUnits
  }

  get companiesSelect() {
    return this.companies
  }

  get buildingsSelect() {
    return this.buildings
  }

  get providersSelect() {
    return this.providers
  }

  get profilesSelect() {
    return this.profiles
  }

  get profilesSelectFiltered() {
    const currentUser = store.state.user
    const isAdmin = currentUser?.account?.profile === ACCOUNT_PROFILE_ADMIN

    return AccountUtils.getProfilesForSelect(isAdmin).map(profile => ({
      value: profile.value,
      label: this.$t(profile.labelKey).toString()
    }))
  }

  get editorialStatusOptions() {
    return [
      { value: 'es usuario editorial', label: this.$t('upsert_account_modal.editorial_status_options.editorial_user') },
      { value: 'no es usuario editorial', label: this.$t('upsert_account_modal.editorial_status_options.not_editorial_user') },
      { value: 'sin revisar', label: this.$t('upsert_account_modal.editorial_status_options.not_reviewed') }
    ]
  }

  async mounted() {
    await this.loadCountries()
    await this.loadBusinessUnits()
    await this.loadCompanies()
    await this.loadBuildings()
    await this.loadProviders()
    await this.loadProfiles()
  }

  private async loadCountries() {
    this.countries = await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY)
  }

  private async loadBusinessUnits() {
    this.businessUnits = await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT)
  }

  private async loadCompanies() {
    try {
      this.companies = await ApiClient.getCompanies()
    } catch (error) {
      console.error('Error loading companies:', error)
    }
  }

  private async loadBuildings() {
    try {
      this.buildings = await ApiClient.getBuildings()
    } catch (error) {
      console.error('Error loading buildings:', error)
    }
  }

  private async loadProviders() {
    try {
      this.providers = await ApiClient.getProviders()
    } catch (error) {
      console.error('Error loading providers:', error)
    }
  }

  private async loadProfiles() {
    this.profiles = await ApiClient.getAccountProfiles()
  }

  private formOk(): boolean {
    return !!this.accountSave.accountId &&
           !!this.accountSave.firstName &&
           !!this.accountSave.lastName &&
           this.metaValid
  }

  private updateAccount() {
    if (this.account && this.account.accountId !== '') {
      Vue.set(this.accountSave, 'accountId', this.account.accountId)
      Vue.set(this.accountSave, 'firstName', this.account.firstName)
      Vue.set(this.accountSave, 'lastName', this.account.lastName)
      Vue.set(this.accountSave, 'active', this.account.active)
      Vue.set(this.accountSave, 'country', this.account.country)
      Vue.set(this.accountSave, 'businessUnit', this.account.businessUnit)
      Vue.set(this.accountSave, 'responsibleCompany', this.account.responsibleCompany)
      Vue.set(this.accountSave, 'profile', this.account.profile || ACCOUNT_PROFILE_USER)
      Vue.set(this.accountSave, 'companyId', this.account.companyId)
      Vue.set(this.accountSave, 'buildingId', this.account.buildingId)
      Vue.set(this.accountSave, 'providerId', this.account.providerId)
      Vue.set(this.accountSave, 'editorialStatus', this.account.editorialStatus)
      Vue.set(this.accountSave, 'meta', this.account.meta || {})
      Vue.set(this.accountSave, 'createdOn', this.account.createdOn)
      Vue.set(this.accountSave, 'updatedOn', this.account.updatedOn)
    } else {
      this.clearForm()
    }
  }

  hideModal() {
    this.$bvModal.hide('UpsertAccountModal')
  }

  private saveForm(): void {
    if (this.formOk()) {
      if (this.account && this.account.accountId) {
        ApiClient.updateAccount(this.accountSave.accountId, this.accountSave)
          .then((accountSaved: Account) => {
            this.$emit('accountSaved', accountSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch((ex: Error) => {
            this.showError(ex.message)
          })
      } else {
        ApiClient.createAccount(this.accountSave)
          .then((accountSaved: Account) => {
            this.$emit('accountSaved', accountSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch((ex: Error) => {
            this.showError(ex.message)
          })
      }
    } else {
      this.showError(this.$t('upsert_account_modal.form_invalid').toString())
    }
  }

  private showError(message: string) {
    this.$bvToast.toast(message || this.$t('feedback.error_message_generic').toString(), {
      title: this.$t('feedback.error_title_generic').toString(),
      variant: 'danger',
      solid: true
    })
  }

  private clearForm() {
    Vue.set(this.accountSave, 'accountId', '')
    Vue.set(this.accountSave, 'firstName', '')
    Vue.set(this.accountSave, 'lastName', '')
    Vue.set(this.accountSave, 'active', true)
    Vue.set(this.accountSave, 'country', null)
    Vue.set(this.accountSave, 'businessUnit', null)
    Vue.set(this.accountSave, 'responsibleCompany', null)
    Vue.set(this.accountSave, 'profile', ACCOUNT_PROFILE_USER)
    Vue.set(this.accountSave, 'companyId', null)
    Vue.set(this.accountSave, 'buildingId', null)
    Vue.set(this.accountSave, 'providerId', null)
    Vue.set(this.accountSave, 'editorialStatus', null)
    Vue.set(this.accountSave, 'meta', {})
    Vue.set(this.accountSave, 'createdOn', '')
    Vue.set(this.accountSave, 'updatedOn', '')
  }
}
